var map = {
	"./accessibility.svg": "1f55",
	"./account_balance.svg": "73b2",
	"./add.svg": "4c70",
	"./add_box.svg": "ca5a",
	"./alarm_on.svg": "3870",
	"./arrow-drop-down.svg": "60e7",
	"./arrow-flat.svg": "f5a5",
	"./arrow-left.svg": "1e8e",
	"./arrow-right.svg": "1970",
	"./arrow_upward.svg": "1e66",
	"./attach.svg": "85e4",
	"./block.svg": "7337",
	"./bookmarks.svg": "41b8",
	"./cached.svg": "98ca",
	"./call.svg": "719f",
	"./call_end.svg": "3057",
	"./cancel.svg": "5341",
	"./center-logo.svg": "4519",
	"./chart.svg": "f3b5",
	"./chat_unic.svg": "1536",
	"./check_box.svg": "bd1b",
	"./check_box_outline_blank.svg": "143f",
	"./chevron_left.svg": "9d43",
	"./clear.svg": "d49c",
	"./close.svg": "f62a",
	"./closeChat.svg": "150e",
	"./close_unic.svg": "29eb",
	"./collapse_unic.svg": "4c7a",
	"./comment.svg": "85d4",
	"./copy.svg": "f19f",
	"./cti-logo.svg": "de2b",
	"./delete.svg": "0d06",
	"./done-all.svg": "7e84",
	"./done.svg": "045b",
	"./download.svg": "ebb9",
	"./dropdown.svg": "9a9a",
	"./edit.svg": "5980",
	"./email.svg": "38dc",
	"./equalizer.svg": "783f",
	"./error.svg": "dec5",
	"./exit.svg": "45cb",
	"./expand_more.svg": "b44d",
	"./facebook.svg": "917d",
	"./file-extension.svg": "0958",
	"./filter_list.svg": "2b36",
	"./find_in_page.svg": "81be",
	"./forward.svg": "32cf",
	"./group.svg": "6f35",
	"./group_work.svg": "0f5a",
	"./grouped_bar_chart.svg": "7602",
	"./hourglass_empty.svg": "60e4",
	"./info.svg": "0372",
	"./info_outline.svg": "90e7",
	"./insert_emoticon.svg": "0ea5",
	"./link.svg": "5d75",
	"./list_alt.svg": "db43",
	"./lock.svg": "9f9d",
	"./logo.svg": "ce80",
	"./maximize.svg": "db39",
	"./mediation.svg": "b83a",
	"./message.svg": "3555",
	"./minimize.svg": "ce32",
	"./mood.svg": "1d2bf",
	"./mood_bad.svg": "4b2d",
	"./more.svg": "887b",
	"./more_vert.svg": "afe4",
	"./no_search.svg": "4ca5",
	"./ok.svg": "35c1",
	"./person.svg": "b6ad",
	"./person_add.svg": "d826",
	"./phone_disabled.svg": "33d2",
	"./phone_enabled.svg": "3f53",
	"./phone_in_talk.svg": "5282",
	"./play.svg": "a9c4",
	"./play_for_work.svg": "9eeb",
	"./power_settings_off.svg": "c1df",
	"./publish.svg": "38fa",
	"./question_answer.svg": "47bb",
	"./radio_button_checked.svg": "4f7d",
	"./radio_button_unchecked.svg": "fac1",
	"./receipt.svg": "99eb",
	"./remove.svg": "a707",
	"./restart_alt.svg": "18f7",
	"./search.svg": "77aa",
	"./search_check.svg": "0acc",
	"./security.svg": "9bbd",
	"./send.svg": "2d1c",
	"./sentiment_satisfied.svg": "a05b",
	"./settings_backup_restore.svg": "222b",
	"./social-fb.svg": "2411",
	"./social-gp.svg": "a0d3",
	"./social-vk.svg": "421a",
	"./star.svg": "3f55",
	"./star_border.svg": "f633",
	"./table_chart.svg": "a809",
	"./telegram.svg": "38aa",
	"./timeline.svg": "7ce6",
	"./timer.svg": "4b0a",
	"./trending-up.svg": "dc21",
	"./tune.svg": "60e6",
	"./upload.svg": "e0b9",
	"./user-anon-dark.svg": "3c70",
	"./user-anon-light.svg": "dd12",
	"./user-anon-transparent.svg": "68ea",
	"./user-client-dark.svg": "4758",
	"./user-client-light.svg": "3385",
	"./user-client-transparent.svg": "06a0",
	"./user-email-dark.svg": "53d4",
	"./user-email-light.svg": "6c69",
	"./user-facebook-dark.svg": "2cc1",
	"./user-facebook-light.svg": "5180",
	"./user-operator-bot.svg": "6d2a",
	"./user-operator-dark.svg": "bb66",
	"./user-operator-light.svg": "94e0",
	"./user-telegram-dark.svg": "0c3b",
	"./user-telegram-light.svg": "175b",
	"./user-viber-dark.svg": "97d3",
	"./user-viber-light.svg": "000e",
	"./user-viber-transparent.svg": "90df",
	"./user-vk-dark.svg": "3d22",
	"./user-vk-light.svg": "b26e",
	"./user-vk-transparent.svg": "03c9",
	"./user-voice-dark.svg": "104c",
	"./user-whatsapp-dark.svg": "aeaf",
	"./user-whatsapp-light.svg": "384f",
	"./user-whatsapp-transparent.svg": "8d08",
	"./viber.svg": "f713",
	"./visibility.svg": "836f",
	"./visibility_off.svg": "4d11",
	"./vk.svg": "ca59",
	"./vpn_key.svg": "f4cb",
	"./warning.svg": "1871",
	"./web.svg": "76c1",
	"./whatsapp.svg": "910e",
	"./work.svg": "8261"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7403";